import { MyCheckbox } from "components";
import InfoTooltip from "components/InfoTooltip";
import { Stack } from "@mui/material";
import React, { useCallback, useMemo } from "react";
import { getOrganizationInfoFromLocalStorage } from "utils/functions";
const TypeCheckBoxes = ({ addNew, formik, edit }) => {
  const {allowInstallments} = getOrganizationInfoFromLocalStorage()

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    formik.setFieldValue(name, type === "checkbox" ? checked : value);
  };

  const isStripe = useMemo(() => formik?.values?.paymentGateway?.provider === "Stripe", [formik.values]);
  const checkEnableAllowMember = useCallback(() => {
    if(!edit) return true;
    if(edit && formik.values?.payement_type_new === "ach" && isStripe) return true;
    if(edit && formik.values?.payement_type_new === "credit card") return true;
    if(edit && formik.values?.payement_type_new === "credit on account") return true;
    return false;
  }, [formik.values, isStripe, edit]);

  const enableAllowMember = useMemo(() => checkEnableAllowMember(), [checkEnableAllowMember]);

  const enableAllowInstallment = useMemo(() => allowInstallments && (formik.values?.payement_type_new === "credit card" || formik.values?.payement_type_new === "ach"), [allowInstallments, formik.values]);

  const enableAllowMemberInstallment = useMemo(() => allowInstallments && (formik.values?.payement_type_new === "credit card" || formik.values?.payement_type_new === "ach")&& formik.values?.allow_member, [allowInstallments, formik.values]);

  return (
    <div className="pt-5 mt-5">
      <div
        className={
          addNew === true || edit === true
            ? "mb-5 pb-5 edit-payment-check-box"
            : "mb-5 pb-5 payment-type-check-box"
        }
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <MyCheckbox
            name={`default_payment_type`}
            title="Default Payment Type"
            handlechange={onChange}
            checked={formik.values?.default_payment_type}
            style={!edit ? { opacity: 0.7, pointerEvents: "none" } : {}}
          />
          <InfoTooltip text="Pre-selects this payment type whenever a new charge or payment is created, across the app." style={{ marginLeft: '6px', marginBottom: '8px' }} />
        </div>
        {enableAllowInstallment && (
          <div style={{ display: "flex", alignItems: "center" }}>
            <MyCheckbox
              name={`allowInstallment`}
              title="Allow Installments"
              handlechange={onChange}
              checked={formik.values?.allowInstallment}
              style={!edit ? { opacity: 0.7, pointerEvents: "none" } : {}}
            />
            <InfoTooltip text="Lets this payment type be used for installment (split) payments." style={{ marginLeft: '6px', marginBottom: '8px' }} />
          </div>
        )}
       <div className="d-flex items-center"
          style={{ gap: "1rem" }}
        >
        
        {/* each checkbox is kept together with its hint */}
        <span className="d-flex align-items-center" style={{ gap: "6px" }}>
        <MyCheckbox
            name={`allow_member`}
            title="Allow Member"
            handlechange={(e) => {
              onChange(e);
              formik.setFieldValue("allowMemberInstallment", false);
            }}
            checked={enableAllowMember ? formik.values?.allow_member : false}
            style={(!edit || !enableAllowMember) ? { opacity: 0.7, pointerEvents: "none" } : {}}

          />
          <InfoTooltip text="Lets members use this payment type themselves from the member portal, not just staff. Available only for payment types that use the Stripe gateway." style={{ marginBottom: '8px' }} />
        </span>
          {enableAllowInstallment && (
            <span className="d-flex align-items-center" style={{ gap: "6px" }}>
            <MyCheckbox
              name={`allowMemberInstallment`}
              title="Allow Member Installment"
              handlechange={onChange}
              checked={enableAllowMemberInstallment ? formik.values?.allowMemberInstallment : false}
              style={(!edit || !enableAllowMemberInstallment) ? { opacity: 0.7, pointerEvents: "none" } : {}}
            />
            <InfoTooltip text="Lets members set up their own installment plan with this payment type. Requires Allow Member and Allow Installments to both be on." style={{ marginBottom: '8px' }} />
            </span>
          )}
       </div>

      

            <Stack direction="row" spacing={3} alignItems="center">

<span className="d-flex align-items-center" style={{ gap: "6px" }}>
          <MyCheckbox

            name={`coverConvenienceFee`}

            title="Convenience fee"

            handlechange={onChange}

            checked={formik.values?.coverConvenienceFee}

            style={!edit ? { opacity: 0.7, pointerEvents: "none" } : {}}

          />

          <InfoTooltip text="Adds an extra fee to the payer's total when they use this payment type." style={{ marginBottom: '8px' }} />
          </span>

          {formik.values?.coverConvenienceFee && (
            <span className="d-flex align-items-center" style={{ gap: "6px" }}>
            <MyCheckbox

              name={`optionalConvenienceFee`}

              title="Optional"

              handlechange={onChange}

              checked={formik.values?.optionalConvenienceFee}

              style={!edit ? { opacity: 0.7, pointerEvents: "none" } : {}}

            />

            <InfoTooltip text="Makes the convenience fee optional for the payer instead of mandatory. You'll need to add a message explaining the fee, shown to the payer at checkout." style={{ marginBottom: '8px' }} />
            </span>
          )}

        </Stack>
      </div>
    </div>
  );
};

export default TypeCheckBoxes;
